<template>
    <Doughnut
            :chart-options="defaultOptions"
            :chart-data="{
                labels: defaultLabels,
                datasets: defaultDatasets
            }"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
    />

</template>

<script>
    import {Doughnut} from 'vue-chartjs/legacy'
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
            BarElement, CategoryScale, LinearScale
    } from 'chart.js'
    import {hexToRgba} from "@coreui/utils/src";

    ChartJS.register(Legend,Title, Tooltip, ArcElement, CategoryScale,BarElement,LinearScale)
    ChartJS.register(ChartDataLabels)
    export default {
        name: 'DoughnutChart',
        components: {
            Doughnut
        },
        props: {
            chartId: {
                type: String,
                default: 'doughnut-chart'
            },
            datasetIdKey: {
                type: String,
                default: 'label'
            },
            width: {
                type: Number,
                default: 200
            },
            height: {
                type: Number,
                default: 200
            },
            cssClasses: {
                default: '',
                type: String
            },
            styles: {
                type: Object,
                default: () => {
                }
            },
            plugins: {
                type: Array,
                default: () => []
            },
            chart_datas: Array,
            label: String,
            barColor: String
        },
        data() {
            return {
                chartData: {datasets: []},
                chartOptions: {}
            }
        },
        mounted() {
            // this.chartData = {
            //     labels: this.defaultLabels,
            //     datasets: this.defaultDatasets
            // }
            this.chartOptions = {
                responsive: true,
                maintainAspectRatio: false
            }

        },
        computed: {
            defaultDatasets() {
                // const brandInfo = getStyle('info') || '#321fdb'

                const data1 = []
                const colors = []
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if (this.chart_datas[i] != null) {

                        data1.push(this.chart_datas[i].count)
                        colors.push(hexToRgba(this.chart_datas[i].color, 100))
                    }

                }

                return [
                    {
                        backgroundColor: colors,
                        pointHoverBackgroundColor: this.barColor,
                        borderWidth: 2,
                        data: data1
                    },

                ]
            },
            defaultLabels() {
                var labels = [];
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if (this.chart_datas[i] != null) {

                        labels.push(this.chart_datas[i].label)
                    }
                }
                return labels;
            },
            defaultOptions() {
                return {
                    plugins: {
                        title: {
                            display: true,
                            text: this.label,
                        },
                        datalabels: {
                            color: '#ffffff',
                            formatter: function (value, context) {
                                return value + "%";
                            }
                        },
                        legend:{
                            position:'left'
                        },
                            scales: {
                                    yAxes: [{
                                            ticks: {
                                                    min: 0,
                                                    max: 300,
                                                    stepSize: 100,
                                                    reverse: false,
                                                    beginAtZero: true
                                            }
                                    }]
                            }

                    },
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: this.label
                    },
                        scales: {
                                yAxes: [{
                                        ticks: {
                                                min: 0,
                                                max: 300,
                                                stepSize: 100,
                                                reverse: false,
                                                beginAtZero: true
                                        }
                                }]
                        },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3
                        }
                    }
                }
            }
        }
    }
</script>
